import React from 'react';

/**
 * CaseStudies — anonymised mandate KPIs + testimonials on dark anthracite.
 * Auto-numbered when inside `.numbered-sections`.
 */
export default function CaseStudies() {
  const pairs = [
    {
      ref: 'Mandat M-028',
      loc: 'Wiesbaden-Mitte · 18 Wohneinheiten',
      pre: 'Denkmalobjekt in Eigenverwaltung aus dem Ausland',
      kpis: [
        ['Kaltmiete p.a. vor Übernahme', '60.240 €'],
        ['Kaltmiete p.a. nach 6 Monaten', '113.636 €'],
        ['Reduktion Leerstandsquote <3 Monaten', '55 % → 0 %'],
      ],
      testimonial: {
        quote:
          'Ich kann hamba und Herrn Dr. Balz ohne Einschränkungen weiterempfehlen. Eine so sorgfältige Arbeit findet man selten.',
        author: 'Ärztin · Immobilieneigentum in 2. Generation · Lungern, Schweiz',
        meta: 'Mandat seit 08.2024 · 18 WE',
      },
    },
    {
      ref: 'Mandat M-013',
      loc: 'Königstein i.Ts. · 17 Wohneinheiten',
      pre: 'Neubau, zwei Investoren mit anspruchsvoller Neuvermietung',
      kpis: [
        ['Zusätzliche Kaltmiete p.a. nach Übernahme', '125.721 €'],
        ['Mieteinzugsquote erste 12 Monate', '100 %'],
        ['Reduktion Leerstandsquote <2 Monaten', '29 % → 5 %'],
      ],
      testimonial: {
        quote:
          'Sehr zuverlässig, kompetent, schnell und freundlich, die Kommunikation ist transparent und professionell — klare Empfehlung!',
        author: 'Unternehmer & Investor · Bad Soden am Taunus.',
        meta: 'Mandat seit 05.2025 · 17 WE',
      },
    },
  ];

  return (
    <section style={{ padding: '140px 0', background: 'var(--anthracite)', color: 'var(--cream)' }}>
      <div className="shell">
        <div
          className="section-label numbered reveal"
          style={{ marginBottom: 28, color: 'rgba(245,242,236,0.55)' }}
        >
          <span style={{ color: 'rgba(245,242,236,0.55)' }}>Fallstudien</span>
        </div>
        <h2 className="h-section reveal" style={{ color: 'var(--cream)', marginBottom: 16, maxWidth: '20ch' }}>
          Mandate, anonymisiert.
        </h2>
        <p
          className="reveal body-prose"
          style={{
            color: 'rgba(245,242,236,0.7)',
            fontSize: 18,
            marginBottom: 88,
            maxWidth: '56ch',
            fontFamily: 'var(--serif)',
            fontStyle: 'italic',
          }}
        >
          Wir setzen auf Vertraulichkeit, weshalb wir darauf verzichten, Namen und Adressen zu nennen.
        </p>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: 0,
            borderTop: '1px solid rgba(245,242,236,0.14)',
            borderBottom: '1px solid rgba(245,242,236,0.14)',
          }}
        >
          {pairs.map((c, i) => (
            <div
              key={i}
              className="reveal"
              style={{
                padding: '44px 40px 44px 0',
                paddingLeft: i % 2 === 0 ? 0 : 40,
                borderRight: i % 2 === 0 ? '1px solid rgba(245,242,236,0.14)' : 'none',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <div
                style={{
                  fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
                  fontSize: 11,
                  letterSpacing: '0.16em',
                  color: 'rgba(245,242,236,0.45)',
                  marginBottom: 12,
                }}
              >
                {c.ref}
              </div>
              <h3
                style={{
                  fontFamily: 'var(--serif)',
                  fontSize: 26,
                  color: 'var(--cream)',
                  marginBottom: 8,
                  lineHeight: 1.25,
                }}
              >
                {c.loc}
              </h3>
              <div
                style={{
                  fontSize: 13,
                  color: 'rgba(245,242,236,0.55)',
                  marginBottom: 36,
                  fontFamily: 'var(--serif)',
                  fontStyle: 'italic',
                }}
              >
                Ausgangslage: {c.pre}
              </div>

              <dl style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 0, marginBottom: 48 }}>
                {c.kpis.map(([k, v], j) => (
                  <div
                    key={j}
                    style={{
                      display: 'grid',
                      gridTemplateColumns: '1fr auto',
                      gap: 24,
                      padding: '16px 0',
                      borderTop: '1px solid rgba(245,242,236,0.10)',
                      alignItems: 'baseline',
                    }}
                  >
                    <dt style={{ fontSize: 14, color: 'rgba(245,242,236,0.65)' }}>{k}</dt>
                    <dd
                      style={{
                        fontFamily: 'var(--serif)',
                        fontSize: 22,
                        color: 'var(--cream)',
                        textAlign: 'right',
                        margin: 0,
                      }}
                    >
                      {v}
                    </dd>
                  </div>
                ))}
              </dl>

              <figure
                style={{
                  margin: 0,
                  marginTop: 'auto',
                  paddingTop: 32,
                  borderTop: '1px solid rgba(245,242,236,0.14)',
                }}
              >
                <div
                  style={{
                    fontFamily: 'var(--serif)',
                    fontSize: 48,
                    lineHeight: 0.5,
                    color: 'var(--bordeaux)',
                    marginBottom: 8,
                  }}
                  aria-hidden="true"
                >
                  “
                </div>
                <blockquote
                  style={{
                    fontFamily: 'var(--serif)',
                    fontStyle: 'italic',
                    fontSize: 22,
                    lineHeight: 1.45,
                    color: 'var(--cream)',
                    margin: 0,
                    maxWidth: '44ch',
                  }}
                >
                  {c.testimonial.quote}
                </blockquote>
                <figcaption
                  style={{
                    marginTop: 24,
                    paddingTop: 16,
                    borderTop: '1px solid rgba(245,242,236,0.14)',
                    fontSize: 14,
                    color: 'rgba(245,242,236,0.8)',
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    gap: 12,
                  }}
                >
                  <span>{c.testimonial.author}</span>
                  <span style={{ color: 'rgba(245,242,236,0.5)' }}>{c.testimonial.meta}</span>
                </figcaption>
              </figure>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
